<template>
    <component :is="currentView"></component>
</template>

<script>
import {mapState} from 'vuex'
import RegExp from 'path-to-regexp'

export default {
    name: 'RouterView', 
    data() {  
        return {  
            currentView: {},
            routes: []
        }
    },
    computed: {
        ...mapState({
            systemTree: state => state.systemTree
        })
    },
    created() {

        var navigations = []

        function parseSystemTree(item) {
            let nav = []
            Object.keys(item).forEach(key => {
                if (item[key].link !== '') {
                    nav.push({
                    path: item[key].link,
                    name: item[key].name,
                    meta: {title: item[key].name},
                    component: item[key].view !== '' ? item[key].view : '404NotFound.vue',
                    children: Object.keys(item[key].child).length > 0 ? parseSystemTree(item[key].child) : []
                    })
                }
            })
            return nav
        }

        if (this.systemTree) {
            navigations = parseSystemTree(this.systemTree)
        }

        this.routes = this.$router.options.routes.concat(navigations)

        let getRouteObject = this.getRouteObject()

        if (getRouteObject === undefined) {
            this.currentView = this.get404Error
        } else {
            this.currentView = getRouteObject;
        }
        
    },
    methods: {
        setStatus() {
            this.$nextTick(() => {
                /**
                 * Sistem loadingStatus'u set et 
                 */
                window.onload = () => {
                    this.$store.commit('setLoadingStatus', false);
                }
                this.$store.commit('setLoadingStatus', false);
            })
        },
        findRoute(routes, path) {
            var router = [],
                keys = []

            // Result
            router[1] = []

            routes.forEach(route => {
                
                if (router[1].length > 0) return false

                var reg = RegExp(route.path, keys)

                router[0] = route
                router[1] = (reg.exec(path) || reg.exec('/' + path)) ?? []
                
            })
            return router
        },
        getRouteObject() {

            let paths = this.$route.fullPath.split('/').filter((path) => path !== '');

            // Hiç yoksa anasayfadır
            paths = paths.length === 0 ? ['/'] : paths;

            let routes = this.routes,
                p,
                keys = [],
                tree = [],
                lastRoute

            paths.forEach((path, pkey) => {

                p = this.findRoute(routes, path)

                if (lastRoute) {
                    lastRoute = null;
                    return;
                }

                if (p[1].length === 0) {
                    lastRoute = routes[routes.length -1]
                    if (typeof lastRoute === 'undefined') return false;
                    RegExp(lastRoute.path, keys)
                    if (keys) {
                        keys.forEach((key, i) => {
                            p[0] = lastRoute
                            p[1] = lastRoute.path.replace(':'+key.name, paths[pkey + (i + 1)])
                            this.$store.commit('Router/setParams', {[key.name]: paths[pkey + (i + 1)]})
                            tree.push(p)
                        })
                    } else {
                        return false;
                    }
                } else {
                    routes = p[0].children
                    p[1] = p[1][0]
                    tree.push(p)
                }


            })
            
            let fullpath = [];
            tree.forEach(r => {
                fullpath.push(r[1])
            })

            this.$store.commit('Router/setHistory', fullpath)

            this.$store.commit('Router/setChilds', tree.map(t => t[0]))

            this.$store.commit('Router/setCurrent', tree[tree.length - 1][0])
            
            fullpath = fullpath.join('/')

            let lastRouteComponent = tree[tree.length - 1][0].component
            
            let route;

            if (fullpath === this.$route.fullPath || fullpath + '/' === this.$route.fullPath) {
                if (typeof lastRouteComponent === 'function')
                    route = lastRouteComponent
                else
                    route = () => import('@/views/' + lastRouteComponent);
            } else {
                route = this.get404Error()
            }

            return route
        },
        get404Error() {
            return () => import('@/views/404NotFound.vue')
        }
    },
    watch:{
        $route(){
            this.currentView = this.getRouteObject()
        }
    },
    mounted() {
        this.setStatus()
    },
    updated() {
        this.setStatus()
    }
}
</script>

<style>

</style>